<template>
    <div>
        <h1>{{$t('error.403page.header')}}</h1>
        <p>
            {{$t('error.403page.description')}}
        </p>
    </div>
</template>
